import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';


@Injectable()
export class OnboardDiagnosticService {

  private endpointURL = 'onboard-diagnostic/all';
  private endpointURL_new = 'onboard-diagnostic/new';
  private serviceBulletinFilter: string;

  constructor(private http: HttpClient ) { }

  getAllOBDManuals(): Observable<any> {
    return this.http.get(this.endpointURL,{withCredentials : true});
  }
  getAllOBDManualsForAdmin(makeName): Observable<any> {
    return this.http.get(this.endpointURL + '/makeName/' + makeName,{withCredentials : true});
  }
  getNewOBDManuals(): Observable<any> {
    return this.http.get(this.endpointURL_new,{withCredentials : true});
  }
  getUserOBDManualHistory(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/obdHistorylist`,{withCredentials : true});
  }
  addOBDManualToUserHistory(userId, manualId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addOBDToHistorylist/${manualId}`, '',{withCredentials : true});
  }

  
  saveFilterData(filter: string) {
    this.serviceBulletinFilter = filter;
  }

  getFilterData(): string {
    return this.serviceBulletinFilter;
  }

}
